import { render, staticRenderFns } from "./rest_details_dialog.vue?vue&type=template&id=51907ceb"
import script from "./rest_details_dialog.vue?vue&type=script&lang=js"
export * from "./rest_details_dialog.vue?vue&type=script&lang=js"
import style0 from "./rest_details_dialog.vue?vue&type=style&index=0&id=51907ceb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports